module.exports = __webpack_public_path__ + "static/media/ErrorIcon.5108d783.svg";